import { BetProps } from './Bet'
import { CallOptionsProps } from './CallOptions'
import { ChatsProps } from './Chats'
import { ConfirmProps } from './Confirm'
import { GameStartProps } from './GameStart'
import { ObserversProps } from './Observers'
import { PlayerOptionsProps } from './PlayerOptions'
import { WalkthroughProps } from './Walkthrough'
import { SidePotsProps } from './SidePots'
import { ThreeCardBetProps } from './ThreeCardBet'
import { ShowCardsProps } from './ShowCards'

export const BottomModalTypes = {
  Chats: 'Chats',
  Confirm: 'Confirm',
  Bet: 'Bet',
  GameStart: 'GameStart',
  PlayerOptions: 'PlayerOptions',
  Walkthrough: 'Walkthrough',
  SidePots: 'SidePots',
  Observers: 'Observers',
  CallOptions: 'CallOptions',
  ThreeCardBet: 'ThreeCardBet',
  ShowCards: 'ShowCards'
} as const
export type BottomModalType = keyof typeof BottomModalTypes

export type BottomModalContentConfig =
  | { kind: 'Chats'; props: ChatsProps }
  | { kind: 'Bet'; props: BetProps }
  | { kind: 'Confirm'; props: ConfirmProps }
  | { kind: 'GameStart'; props: GameStartProps }
  | { kind: 'PlayerOptions'; props: PlayerOptionsProps }
  | { kind: 'Walkthrough'; props: WalkthroughProps }
  | { kind: 'SidePots'; props: SidePotsProps }
  | { kind: 'Observers'; props: ObserversProps }
  | { kind: 'CallOptions'; props: CallOptionsProps }
  | { kind: 'ThreeCardBet'; props: ThreeCardBetProps }
  | { kind: 'ShowCards'; props: ShowCardsProps }

export * from './Chats'
export * from './Confirm'
export * from './Bet'
export * from './GameStart'
export * from './Observers'
export * from './PlayerOptions'
export * from './Walkthrough'
export * from './SidePots'
export * from './ThreeCardBet'
export * from './ShowCards'
